module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9b76d6a33034ea42a6c2261fa42f73d9.png";